function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { iconValid } from '../helpers';
import { TRow } from '../components/Table/TRow';
import { TData } from '../components/Table/TData';
import { TDContainer, HeaderItem, Label, Grip, ResponsiveHeader } from '../components/Table/styles';
import { Draggable } from '@hello-pangea/dnd';
import _ from 'lodash';
export const headers = ['NAME', 'DESCRIPTION', 'DEFAULT'];
export const columnLayout = '10rem 1fr 7rem';
const sort = (rows, headerIndex, ascending) => {
  const sorted = rows?.sort((a, b) => {
    const key = Object.keys(a)[headerIndex];
    const val1 = a[key];
    const val2 = b[key];
    if (val1 === null) return 0;
    if (val1 < val2 || val2 === null) return ascending ? -1 : 1;
    if (val1 > val2) return ascending ? 1 : -1;
    return 0;
  });
  return sorted || rows;
};
const hasLabel = rows => rows?.find(obj => Object.keys(obj).includes('label'));
export const buildHeaders = args => {
  const {
    sortable,
    sortedColumn,
    setSortedColumn,
    ascending,
    setAscending,
    content,
    ...rest
  } = args;
  const handleSort = (header, index) => {
    if (sortedColumn !== header) setSortedColumn(header);
    if (sortable) {
      const newArr = sort(content?.rows, index, ascending);
      setAscending(!ascending);
      sortable(newArr);
    }
  };
  const headings = content?.headers?.map((header, index) => /*#__PURE__*/React.createElement(HeaderItem, {
    key: index,
    $sortable: sortable,
    onClick: () => handleSort(header, index)
  }, sortable && header === sortedColumn && /*#__PURE__*/React.createElement("i", {
    className: `fa-solid fa-arrow-${ascending ? 'up' : 'down'}`
  }), " ", header));
  return /*#__PURE__*/React.createElement(TRow, _extends({
    header: true,
    headers: content?.headers,
    hasLabel: hasLabel(content?.rows)
  }, rest), headings);
};
export const buildRows = args => {
  const {
    theme,
    selectedTheme,
    ascending,
    columnLayout,
    sortedColumn,
    sortable,
    draggable,
    content,
    mobileSize
  } = args;
  const index = content?.headers?.indexOf(sortedColumn);
  if (sortable && index !== -1) sort(content?.rows, index, !ascending);
  return content?.rows?.map((obj, index) => /*#__PURE__*/React.createElement(Draggable, {
    key: index,
    draggableId: index.toString(),
    index: index,
    isDragDisabled: !draggable
  }, (provided, snapshot) => /*#__PURE__*/React.createElement(TRow, _extends({
    theme: theme,
    selectedTheme: selectedTheme,
    className: draggable || obj.onClick ? 'hover' : '',
    columnLayout: columnLayout,
    rows: content?.rows,
    headers: content?.headers,
    isDragging: snapshot.isDragging,
    onClick: e => obj.onClick && obj.onClick(e),
    provided: provided,
    draggable: draggable && true,
    callback: obj.onClick,
    hasLabel: hasLabel(content?.rows),
    mobileSize: mobileSize
  }, args), buildData(obj, args))));
};
const buildData = (obj, args) => {
  const {
    draggable,
    dragIcon,
    labelTextColor,
    labelBGColor,
    content,
    mobileSize
  } = args;
  const {
    label,
    ...rest
  } = obj;
  return Object.values(rest).map((val, index) => {
    const headerItem = content?.headers?.[index];
    const headerText = headerItem?.toLowerCase?.();
    return /*#__PURE__*/React.createElement(TDContainer, {
      key: index,
      $mobileSize: mobileSize
    }, label && index === 0 && /*#__PURE__*/React.createElement(Label, {
      labelTextColor: labelTextColor,
      labelBGColor: labelBGColor
    }, label), /*#__PURE__*/React.createElement(TData, null, /*#__PURE__*/React.createElement(ResponsiveHeader, {
      $mobileSize: mobileSize
    }, typeof headerItem === 'object' ? headerItem : _.startCase(headerText), headerItem ? ':' : ''), typeof val !== 'function' && (val ?? '—')), draggable && index === Object.values(rest).length - 1 && /*#__PURE__*/React.createElement(Grip, null, /*#__PURE__*/React.createElement("i", {
      className: iconValid(dragIcon) || 'fa-solid fa-grip-vertical'
    }), "\xA0"));
  });
};